const fieldAdmin = {}

export default fieldAdmin
